import moment from "moment";
import { RepeatInterval } from "../types/enums";
import InifinteQueue from "./InfiniteQueue";
import toNextIsoWeekday from "./toNextIsoWeekday";

const repeatSelectionToDateTimes = (selection) => {
  const { every, interval, baseDateTime, beginDate, endDate, weekDays } =
    selection;

  if (
    every < 1 ||
    every > 99 ||
    !interval ||
    !baseDateTime ||
    !beginDate ||
    !endDate ||
    (interval === RepeatInterval.WEEK &&
      !Object.values(weekDays).some((v) => v))
  )
    return [];

  const weekdaysQueue = new InifinteQueue(weekDays.sort());

  while (
    weekDays.length > 1 &&
    moment(beginDate).isoWeekday() <= Math.max(...weekdaysQueue.items) &&
    weekdaysQueue.peek() < moment(beginDate).isoWeekday()
  ) {
    weekdaysQueue.dequeue();
  }

  const datetimes = [];

  for (
    var m =
      interval === RepeatInterval.DAY ||
      moment(beginDate).isoWeekday() === weekdaysQueue.peek()
        ? moment(beginDate)
        : moment(toNextIsoWeekday(beginDate, weekdaysQueue.dequeue()));
    m.isSameOrBefore(endDate, "day");
    interval === RepeatInterval.DAY
      ? m.add(every, interval)
      : m.set(
          moment(
            toNextIsoWeekday(m.toDate(), weekdaysQueue.dequeue()),
          ).toObject(),
        )
  ) {
    if (moment(beginDate).isSame(m)) weekdaysQueue.dequeue();
    datetimes.push(
      moment(m)
        .set({
          hour: moment(baseDateTime).get("hour"),
          minute: moment(baseDateTime).get("minute"),
          second: moment(baseDateTime).get("second"),
          millisecond: moment(baseDateTime).get("millisecond"),
        })
        .toDate(),
    );
  }

  return datetimes;
};

export default repeatSelectionToDateTimes;



// WEBPACK FOOTER //
// ./src/helpers/repeatSelectionToDateTimes.js